import {
  CalendarCheck02Icon,
  CalendarDateIcon,
  CalendarMinus02Icon,
  Flag06Icon,
} from "@/icons";
import { IconType } from "@/utils/types";
import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

export type SectionKind = "tutorial" | "active" | "upcoming" | "closed";

export const SECTIONS = Object.freeze([
  {
    to: "/challenges/tutorial",
    key: "tutorial",
    variant: "info",
    label: <FormattedMessage defaultMessage="Get Started" />,
    Icon: Flag06Icon,
  },
  {
    to: "/challenges/active",
    key: "active",
    variant: "success",
    label: <FormattedMessage defaultMessage="Active" />,
    Icon: CalendarCheck02Icon,
  },
  {
    to: "/challenges/upcoming",
    key: "upcoming",
    variant: "warning",
    label: <FormattedMessage defaultMessage="Upcoming" />,
    Icon: CalendarDateIcon,
  },
  {
    to: "/challenges/closed",
    key: "closed",
    variant: "error",
    label: <FormattedMessage defaultMessage="Recently Closed" />,
    Icon: CalendarMinus02Icon,
  },
] as const satisfies ReadonlyArray<{
  key: SectionKind;
  variant: "info" | "success" | "warning" | "error";
  label: ReactNode;
  Icon: IconType;
  to: string;
}>);
